/**考核模块 */
import request from '../request/http';
/**分页查询虚拟仿真软件 */
export function VirtualSoftwarePageList(data){
    return request({
        url: '/sp/examine/virtualSoftwarePageList',
        method: 'post',
        data
    })
}
/**分页查询考核任务 */
export function PageQueryExamine(data){
    return request({
        url: '/sp/examine/pageQueryExamine',
        method: 'post',
        data
    })
}
/**新增考核 */
export function SaveExamine(data){
    return request({
        url: '/sp/examine/saveExamine',
        method: 'post',
        data
    })
}
/**修改考核 */
export function UpdateExamine(data){
    return request({
        url: '/sp/examine/updateExamine',
        method: 'post',
        data
    })
}
/**分页查询虚仿考试已考用户信息 */
export function GetExamineUser(data){
    return request({
        url: '/sp/examine/getExamineUser',
        method: 'post',
        data
    })
}
/**分页查询虚仿考试在考用户信息 */
export function GetInExamineUser(data){
    return request({
        url: '/sp/examine/getInExamineUser',
        method: 'post',
        data
    })
}
/**分页查询虚仿考试未考用户信息 */
export function GetNotExamineUser(data){
    return request({
        url: '/sp/examine/getNotExamineUser',
        method: 'post',
        data
    })
}
/**查询虚仿考核详情 */
export function GetSoftwareExamineDetailById(data){
    return request({
        url: '/sp/examine/getSoftwareExamineDetailById',
        method: 'post',
        data
    })
}
/**考核分数配置详情 */
export function GetSoftwareConfigScore(data){
    return request({
        url: '/sp/examine/getSoftwareConfigScore',
        method: 'post',
        data
    })
}
/**分页查询虚仿考核得分 */
export function PageQuerySoftwareScore(data){
    return request({
        url: '/sp/examine/PageQuerySoftwareScore',
        method: 'post',
        data
    })
}
/**删除考核 */
export function DeleteExamine(data){
    return request({
        url: '/sp/examine/deleteExamine',
        method: 'post',
        data
    })
}
/**查询考核详情 */
export function GetExamineDetailById(data){
    return request({
        url: '/sp/examine/getExamineDetailById',
        method: 'post',
        data
    })
}
/**实训得分数查询 */
export function GetSoftwareScoreTree(data){
    return request({
        url: `/sp/examine/getSoftwareScoreTree`,
        method: 'post',
        data
    })
}
/**分页查询学生考核任务 */
export function PageExamineStd(data){
    return request({
        url: `/sp/examineStd/pageQueryExamine`,
        method: 'post',
        data
    })
}
/**推送考核记录 */
export function PushExamineRecord(data){
    return request({
        url: `/sp/examine/pushExamineRecord`,
        method: 'post',
        data
    })
}
/**临时组卷 */
export function AddTempPaper(data){
    return request({
        url: `/sp/examine/addTempPaper`,
        method: 'post',
        data
    })
}
/**理论考核-试卷库分页(手动出题) */
export function PaperBankPageList(data){
    return request({
        url: `/sp/examine/paperBankPageList`,
        method: 'post',
        data
    })
}
/**理论考核-试卷题目分页 */
export function PaperQuestionPageList(data){
    return request({
        url: `/sp/examine/paperQuestionPageList`,
        method: 'post',
        data
    })
}
/**批量排除题目 */
export function BatchExcludeQuestion(data){
    return request({
        url: `/sp/examine/batchExcludeQuestion`,
        method: 'post',
        data
    })
}
/**获取考核下排除题目 */
export function GetExamineExcludeQuestionIds(data){
    return request({
        url: `/sp/examine/getExamineExcludeQuestionIds`,
        method: 'post',
        data
    })
}
/**通过考核id获取试卷配置 */
export function GetExaminePaperConfig(data){
    return request({
        url: `/sp/examine/getExaminePaperConfig`,
        method: 'post',
        data
    })
}
/**分页查询(已考-未考)用户信息 */
export function GetExamineUserInfo(data){
    return request({
        url: `/sp/examine/getExamineUserInfo`,
        method: 'post',
        data
    })
}
/**通过考核id获取理论试卷(组合) */
export function GetExaminePaperId(data){
    return request({
        url: `/sp/examine/getExaminePaperId`,
        method: 'post',
        data
    })
}
/**缓存试卷答案 */
export function TestPaperAnswerCache(data){
    return request({
        url: `/sp/examine/testPaperAnswerCache`,
        method: 'post',
        data
    })
}
/**理论考核-交卷 */
export function TestPaperSubmit(data){
    return request({
        url: `/sp/examine/testPaperSubmit`,
        method: 'post',
        data
    })
}
/**获取缓存答案 */
export function TestPaperAnswerCacheList(data){
    return request({
        url: `/sp/examine/testPaperAnswerCacheList`,
        method: 'post',
        data
    })
}
/**理论考核-切屏次数 */
export function ScreenEvent(data){
    return request({
        url: `/sp/examine/screenEvent`,
        method: 'post',
        data
    })
}
/**理论考核成绩分页 */
export function ExaminePaperScorePage(data){
    return request({
        url: `/sp/examine/examinePaperScorePage`,
        method: 'post',
        data
    })
}
/**补考-重置考试 */
export function ExaminationReset(data){
    return request({
        url: `/sp/examine/examinationReset`,
        method: 'post',
        data
    })
}
/**查询考核详情(综合考核学生端) */
export function QueryExamineDetailById(data){
    return request({
        url: `/sp/examineStd/getExamineDetailById`,
        method: 'post',
        data
    })
}
/**查询综合考核详情（教师端） */
export function GetSynthExamineDetailById(data){
    return request({
        url: `/sp/examine/getSynthExamineDetailById`,
        method: 'post',
        data
    })
}
/**成绩导出 */
export function ExamineScoreExport(data){
    return request({
        url: `/sp/examine/examineScoreExport`,
        method: 'post',
        responseType: 'blob',
        data
    })
}